import { ReactComponent as Email } from './icon.svg'

export default Email
